var map = {
	"./1-detail.jpg": 1101,
	"./2-detail.jpg": 1102,
	"./4-detail.jpg": 1103,
	"./6-detail.jpg": 1104,
	"./7-detail.jpg": 1105,
	"./Thinkpad_X1_Carbon_Premium_LCD_closeup_sh02.jpg": 1106,
	"./Yoga_002.jpg": 1107,
	"./about-service/img_2.jpg": 1108,
	"./about/Izobrazhenie_3.jpg": 1109,
	"./about/Izobrazhenie_4_2.jpg": 1110,
	"./about/about-photo-1.jpg": 1111,
	"./about/about-photo-2.jpg": 1112,
	"./about/about-photo-3.jpg": 1113,
	"./about/about-photo-4.jpg": 1114,
	"./about/about-photo-5.jpg": 1115,
	"./about/about-photo-6.jpg": 1116,
	"./about/about-photo-7.jpg": 1117,
	"./about/about-photo-8.jpg": 1118,
	"./about/about-photo-9.jpg": 1119,
	"./about/about-promo-bg-900-599.jpg": 1120,
	"./about/about-promo-bg.jpg": 1121,
	"./alfa-direkt-1.jpg": 1122,
	"./author-1.jpg": 1123,
	"./author-1@2x.jpg": 1124,
	"./author-2.jpg": 1125,
	"./author-2@2x.jpg": 1126,
	"./author-3.jpg": 1127,
	"./author-3@2x.jpg": 1128,
	"./author-4.jpg": 1129,
	"./author-4@2x.jpg": 1130,
	"./author-5.jpg": 1131,
	"./author-5@2x.jpg": 1132,
	"./author-6.jpg": 1133,
	"./author-6@2x.jpg": 1134,
	"./bg-promo-three-mobile.jpg": 1135,
	"./bg-promo-three-mobile@2x.jpg": 1136,
	"./bg-promo-three.jpg": 1137,
	"./bg-promo-three@2x.jpg": 1138,
	"./bill/product-detail-marketing-promo-bg-mobile.jpg": 498,
	"./bill/product-detail-marketing-promo-bg.jpg": 497,
	"./bittner-pharma-1.jpg": 1139,
	"./brochure-promo-bg.jpg": 1140,
	"./brochure/avatar-1.jpg": 1141,
	"./brochure/avatar-2.jpg": 1142,
	"./brochure/avatar-3.jpg": 1143,
	"./brochure/avatar-4.jpg": 1144,
	"./brochure/avatar-5.jpg": 1145,
	"./brochure/brochure-promo-bg.jpg": 1146,
	"./categories/skin-1.jpg": 607,
	"./categories/skin-2.jpg": 606,
	"./categories/skin-4.jpg": 610,
	"./categories/skin-5.jpg": 612,
	"./categories/skin-6.jpg": 614,
	"./categories/skin-7.jpg": 615,
	"./categories/skin-8.jpg": 603,
	"./choose-platform/brochure-promo-bg.jpg": 1147,
	"./clients-items/alfa_bank/alfa-bank-1.jpg": 560,
	"./clients-items/amplua_broker/amplua-broker-bg.jpg": 561,
	"./clients-items/bittner_farma/bittner-farma-1.jpg": 562,
	"./clients-items/completo/completo-bg.jpg": 563,
	"./clients-items/completo/completo-review-avatar.jpg": 447,
	"./clients-items/faberlic/faberlic-bg.jpg": 565,
	"./clients-items/fokus_media/fokus-media-1.jpg": 1148,
	"./clients-items/foodik/foodik-bg.jpg": 566,
	"./clients-items/ilearney/ilearney-1.jpg": 1149,
	"./clients-items/lenovo/lenovo-bg-content-3.jpg": 1150,
	"./clients-items/lenovo/lenovo-bg.jpg": 1151,
	"./clients-items/lenovo/lenovo-review-avatar.jpg": 1152,
	"./clients-items/mgu/mgu-1.jpg": 569,
	"./clients-items/mgu/mgu-bg.jpg": 567,
	"./clients-items/mgu/mgu-review-avatar.jpg": 466,
	"./clients-items/mgu/mgu-video-poster.jpg": 568,
	"./clients-items/midea/midea-1.jpg": 571,
	"./clients-items/midea/midea-bg.jpg": 570,
	"./clients-items/qiwi/qiwi-bg.jpg": 1153,
	"./clients-items/review-bg.jpg": 462,
	"./clients-items/rudn/rudn-1.jpg": 572,
	"./clients-items/see-also/fokus-media-skin.jpg": 460,
	"./clients-items/see-also/ilearney-logo.jpg": 478,
	"./clients-items/see-also/ilearney-skin.jpg": 477,
	"./clients-items/see-also/lenovo-skin.jpg": 461,
	"./clients-items/see-also/rudn-skin.jpg": 1154,
	"./clients-items/siemens/siemens-bg.jpg": 573,
	"./completo/skin-detail-completo-promo.jpg": 1155,
	"./completo/skin-detail-completo-review-avatar.jpg": 1156,
	"./completo/skin-detail-completo-video-poster.jpg": 564,
	"./completo/skin-detail-msu-video-poster.jpg": 1157,
	"./contacts/contacts--promo.jpg": 598,
	"./contacts/contacts-photo.jpg": 1158,
	"./contacts/product-detail-promo-bg.jpg": 1159,
	"./content-page-promo-bg.jpg": 448,
	"./content/content-page-promo-bg.jpg": 1160,
	"./content/content-photo.jpg": 1161,
	"./control-1-760.jpg": 1162,
	"./control-1.jpg": 1163,
	"./control-1@2x.jpg": 1164,
	"./control-3-760.jpg": 1165,
	"./control-3.jpg": 1166,
	"./control-3@2x.jpg": 1167,
	"./control-4-760.jpg": 1168,
	"./control-4.jpg": 1169,
	"./control-4@2x.jpg": 1170,
	"./director-speech/director-speech-bg.jpg": 1171,
	"./efficiency-mark-2.jpg": 1172,
	"./efficiency-mark-2@2x.jpg": 1173,
	"./faq_and_support/support.jpg": 599,
	"./faq_and_support/support_2x.jpg": 1174,
	"./forum-madia-1.jpg": 1175,
	"./functions/for-learning/data-handling-screen-1.jpg": 1176,
	"./functions/for-learning/data-handling-screen-2.jpg": 1177,
	"./functions/for-learning/easy-learn-photo.jpg": 1178,
	"./functions/for-learning/fast-start-photo.jpg": 1179,
	"./functions/for-learning/planning-screen.jpg": 1180,
	"./functions/for-learning/product-detail-promo-bg.jpg": 1181,
	"./functions/for-marketing/landings-bg.jpg": 1182,
	"./functions/for-marketing/landings-screen-2.jpg": 1183,
	"./functions/for-marketing/landings.jpg": 1184,
	"./functions/for-marketing/payments-screen-12.jpg": 1185,
	"./functions/for-marketing/payments-screen-13.jpg": 1186,
	"./functions/for-marketing/product-detail-marketing-promo-bg.jpg": 507,
	"./functions/for-marketing/statistic-screen-1.jpg": 1187,
	"./functions/for-marketing/statistic-screen-2.jpg": 1188,
	"./functions/for-marketing/video-editor-bg.jpg": 1189,
	"./functions/for-meetings/product-detail-meeting-promo-bg.jpg": 1190,
	"./functions/for-meetings/statistic-screen-3.jpg": 1191,
	"./functions/for-meetings/statistic-screen-4.jpg": 1192,
	"./functions/for-meetings/statistic-screen-5.jpg": 1193,
	"./functions/product-detail-broadcasting-bg.jpg": 552,
	"./functions/product-detail-promo-bg-900-591.jpg": 644,
	"./functions/product-detail-promo-bg.jpg": 465,
	"./gos-bg-mobile.jpg": 1194,
	"./gos-bg.jpg": 1195,
	"./ilearney-1.jpg": 1196,
	"./industry-healthcare/form-image.jpg": 1197,
	"./industry-healthcare/image.jpg": 1198,
	"./industry-healthcare/image_mobile.jpg": 1199,
	"./industry-healthcare/promo.jpg": 1200,
	"./industry-healthcare/promo_mobile.jpg": 1201,
	"./industry-healthcare/promo_tablet.jpg": 1202,
	"./interface/apple.jpg": 1203,
	"./interface/interface-screen-1.jpg": 1204,
	"./interface/interface-screen-10.jpg": 1205,
	"./interface/interface-screen-11.jpg": 1206,
	"./interface/interface-screen-12.jpg": 1207,
	"./interface/interface-screen-13.jpg": 1208,
	"./interface/interface-screen-14.jpg": 1209,
	"./interface/interface-screen-2.jpg": 1210,
	"./interface/interface-screen-3.jpg": 1211,
	"./interface/interface-screen-4.jpg": 1212,
	"./interface/interface-screen-5.jpg": 600,
	"./interface/interface-screen-6.jpg": 601,
	"./interface/interface-screen-7.jpg": 602,
	"./interface/interface-screen-8.jpg": 1213,
	"./interface/interface-screen-9.jpg": 1214,
	"./logo-ilearney.jpg": 1215,
	"./logo/UhMbtVsiemens2.jpg": 1216,
	"./logo/amplua.jpg": 1217,
	"./logo/completo.jpg": 1218,
	"./logo/faberlic.jpg": 1219,
	"./logo/it_2.jpg": 1220,
	"./logo/logo-amplua.jpg": 613,
	"./logo/logo-bittner-farma.jpg": 608,
	"./logo/logo-completo.jpg": 616,
	"./logo/logo-faberlic.jpg": 609,
	"./logo/logo-ilearney.jpg": 611,
	"./logo/logo-platezhnye-sistemy-qiwi.jpg": 1221,
	"./logo/logo-qiwi.jpg": 604,
	"./logo/logo-siemens.jpg": 605,
	"./main/main--reviews/reviews-author-1.jpg": 1222,
	"./main/main--reviews/reviews-author-2.jpg": 1223,
	"./main/main--reviews/reviews-author-3.jpg": 1224,
	"./meetings-skype/author-review.jpg": 1225,
	"./meetings-zoom/author-review.jpg": 1226,
	"./midea-bg.jpg": 1227,
	"./midea-img1.jpg": 1228,
	"./multilingualism.jpg": 1229,
	"./multilingualism@2x.jpg": 1230,
	"./online-learning-1.jpg": 1231,
	"./online-learning-1@2x.jpg": 1232,
	"./online-learning-3.jpg": 1233,
	"./online-learning-3@2x.jpg": 1234,
	"./online-learning-4.jpg": 1235,
	"./online-learning-4@2x.jpg": 1236,
	"./paralax-content-mobile.jpg": 1237,
	"./paralax-content.jpg": 1238,
	"./partners-bg.jpg": 1239,
	"./partners/contacts_mobile.jpg": 643,
	"./partners/contacts_tablet.jpg": 641,
	"./partners/promo_desktop.jpg": 640,
	"./partners/promo_mobile.jpg": 642,
	"./personaldemo/event-1.jpg": 1240,
	"./platform.jpg": 1241,
	"./platform/platform.jpg": 1242,
	"./platform/platform@2x.jpg": 1243,
	"./platform@2x.jpg": 1244,
	"./price.jpg": 1245,
	"./product-detail-promo-bg.jpg": 1246,
	"./product-detail/product-detail-marketing-promo-bg.jpg": 1247,
	"./product-detail/product-detail-promo-bg.jpg": 1248,
	"./products-comdi/capability-img_1.jpg": 859,
	"./products-comdi/capability-img_2.jpg": 860,
	"./products-comdi/capability-img_3.jpg": 861,
	"./products-comdi/capability-slider-img_1--mobile.jpg": 645,
	"./products-comdi/capability-slider-img_1.jpg": 862,
	"./products-comdi/capability-slider-img_2--mobile.jpg": 646,
	"./products-comdi/capability-slider-img_2.jpg": 863,
	"./products-comdi/capability-slider-img_3--mobile.jpg": 647,
	"./products-comdi/capability-slider-img_3.jpg": 864,
	"./products-comdi/form-img.jpg": 648,
	"./products-comdi/img_bg.jpg": 533,
	"./products-comdi/organization-img_2--mobile.jpg": 649,
	"./products-comdi/organization-img_2--tablet.jpg": 865,
	"./products-comdi/organization-img_2.jpg": 866,
	"./products-messenger/tariffs_card_1.jpg": 650,
	"./products-messenger/tariffs_card_2.jpg": 651,
	"./products-messenger/tariffs_card_2_mobile.jpg": 867,
	"./products-on-premise/case-1-mobile.jpg": 652,
	"./products-on-premise/case-1-tablet.jpg": 653,
	"./products-on-premise/case-1.jpg": 654,
	"./products-on-premise/image_1.jpg": 655,
	"./products-on-premise/image_1_mobile.jpg": 656,
	"./products-on-premise/image_1_tablet.jpg": 657,
	"./products-on-premise/image_3.jpg": 658,
	"./products-on-premise/slide_1.jpg": 659,
	"./products-on-premise/slide_2.jpg": 660,
	"./products-on-premise/slide_3.jpg": 661,
	"./products-on-premise/slide_4.jpg": 662,
	"./products-rooms/for_who_1.jpg": 663,
	"./products-rooms/for_who_1_mobile.jpg": 664,
	"./products-rooms/for_who_1_tablet.jpg": 665,
	"./products-rooms/for_who_2.jpg": 666,
	"./products-rooms/for_who_2_mobile.jpg": 667,
	"./products-rooms/for_who_2_tablet.jpg": 668,
	"./products-rooms/for_who_3.jpg": 669,
	"./products-rooms/for_who_3_mobile.jpg": 670,
	"./products-rooms/for_who_3_tablet.jpg": 671,
	"./products-rooms/image_2.jpg": 672,
	"./products-rooms/image_2_mobile.jpg": 673,
	"./products-rooms/image_2_tablet.jpg": 674,
	"./products-rooms/image_3.jpg": 675,
	"./products-rooms/image_3_mobile.jpg": 676,
	"./products-rooms/image_3_tablet.jpg": 677,
	"./products-rooms/image_4.jpg": 678,
	"./products-rooms/photo_1.jpg": 679,
	"./products-rooms/photo_2.jpg": 680,
	"./products-rooms/photo_3.jpg": 681,
	"./products-rooms/photo_4.jpg": 682,
	"./products-rooms/video.jpg": 1249,
	"./products-webinars/cases/cases-author-1.jpg": 1250,
	"./products-webinars/cases/cases-author-2.jpg": 1251,
	"./products-webinars/cases/cases-author-3.jpg": 1252,
	"./products-webinars/cases/cases-author-4.jpg": 1253,
	"./products-webinars/cases/cases-author-5.jpg": 1254,
	"./products-webinars/cases/cases-author-6.jpg": 1255,
	"./products-webinars/cases/cases-logo-1.jpg": 1256,
	"./products-webinars/cases/cases-logo-2.jpg": 1257,
	"./products-webinars/cases/cases-logo-3.jpg": 1258,
	"./products-webinars/cases/cases-logo-4.jpg": 1259,
	"./products-webinars/cases/cases-logo-5.jpg": 1260,
	"./products-webinars/cases/cases-logo-6.jpg": 1261,
	"./products-webinars/devices_1_1920.jpg": 1262,
	"./products-webinars/devices_1_375.jpg": 1263,
	"./products-webinars/devices_1_768.jpg": 1264,
	"./products-webinars/devices_2_1920.jpg": 1265,
	"./products-webinars/devices_2_375.jpg": 1266,
	"./products-webinars/devices_2_768.jpg": 1267,
	"./products-webinars/link-on-premise-bg_1920.jpg": 1268,
	"./products-webinars/link-on-premise-bg_375.jpg": 1269,
	"./products-webinars/link-on-premise-bg_768.jpg": 1270,
	"./products-webinars/webinars--detail/1.1.jpg": 1271,
	"./products-webinars/webinars--detail/1.2.jpg": 1272,
	"./products-webinars/webinars--detail/1.3.jpg": 1273,
	"./products-webinars/webinars--detail/2.1.jpg": 1274,
	"./products-webinars/webinars--detail/2.2.jpg": 1275,
	"./products-webinars/webinars--detail/2.3.jpg": 1276,
	"./products-webinars/webinars--detail/3.1.jpg": 1277,
	"./products-webinars/webinars--detail/3.2.jpg": 1278,
	"./products-webinars/webinars--detail/3.3.jpg": 1279,
	"./products-webinars/webinars--detail/4.1.jpg": 1280,
	"./products-webinars/webinars--detail/4.2.jpg": 1281,
	"./products-webinars/webinars--detail/4.3.jpg": 1282,
	"./products-webinars/webinars--exp/reviews/author-1.jpg": 1283,
	"./products-webinars/webinars--exp/reviews/author-2.jpg": 1284,
	"./products-webinars/webinars--exp/reviews/author-3.jpg": 1285,
	"./products-webinars/webinars--expand/1440 kurs.jpg": 683,
	"./products-webinars/webinars--form/992_form.jpg": 868,
	"./products-webinars/webinars--form/form_desktop.jpg": 869,
	"./products-webinars/webinars--form/form_mobile.jpg": 870,
	"./products-webinars/webinars--media/1.jpg": 1286,
	"./products-webinars/webinars--tariffs/1440_tarif.jpg": 871,
	"./products-webinars/webinars--tariffs/375 tarif.jpg": 872,
	"./products-webinars/webinars--tariffs/768_tarif.jpg": 873,
	"./products-webinars/webinars--top/1440_top.jpg": 874,
	"./products-webinars/webinars--top/768_top.jpg": 875,
	"./products-webinars/webinars-form__1920.jpg": 1287,
	"./products-webinars/webinars_1_1920.jpg": 1288,
	"./products-webinars/webinars_1_375.jpg": 1289,
	"./products-webinars/webinars_1_768.jpg": 1290,
	"./products-webinars/webinars_2_1920.jpg": 1291,
	"./products-webinars/webinars_2_375.jpg": 1292,
	"./products-webinars/webinars_3_1920.jpg": 1293,
	"./products-webinars/webinars_3_375.jpg": 1294,
	"./products-webinars/webinars_6_1920.jpg": 1295,
	"./products-webinars/webinars_6_375.jpg": 1296,
	"./products-webinars/webinars_7_1920.jpg": 1297,
	"./products-webinars/webinars_7_375.jpg": 1298,
	"./products-webinars/webinars_7_768.jpg": 1299,
	"./products-westudy/form_image.jpg": 876,
	"./products-westudy/form_image_mobile.jpg": 877,
	"./products-westudy/form_image_tablet.jpg": 878,
	"./products-westudy/head.jpg": 879,
	"./products-westudy/head_mobile.jpg": 880,
	"./products-westudy/head_tablet.jpg": 881,
	"./products-westudy/image_1.jpg": 882,
	"./products-westudy/image_1_mobile.jpg": 883,
	"./products-westudy/image_1_tablet.jpg": 884,
	"./products-westudy/image_2.jpg": 885,
	"./products-westudy/image_2_mobile.jpg": 886,
	"./products-westudy/image_2_tablet.jpg": 887,
	"./products-westudy/involvement_1.jpg": 888,
	"./products-westudy/involvement_1_mobile.jpg": 889,
	"./products-westudy/involvement_1_tablet.jpg": 890,
	"./products-westudy/involvement_2.jpg": 891,
	"./products-westudy/involvement_2_mobile.jpg": 892,
	"./products-westudy/involvement_2_tablet.jpg": 893,
	"./products-westudy/involvement_3.jpg": 894,
	"./products-westudy/involvement_3_mobile.jpg": 895,
	"./products-westudy/involvement_3_tablet.jpg": 896,
	"./products-westudy/paperwork_1.jpg": 897,
	"./products-westudy/paperwork_1_mobile.jpg": 898,
	"./products-westudy/paperwork_1_tablet.jpg": 899,
	"./products-westudy/paperwork_2.jpg": 900,
	"./products-westudy/paperwork_2_mobile.jpg": 901,
	"./products-westudy/paperwork_2_tablet.jpg": 902,
	"./products-westudy/paperwork_3.jpg": 903,
	"./products-westudy/paperwork_3_mobile.jpg": 904,
	"./products-westudy/paperwork_3_tablet.jpg": 905,
	"./products-westudy/platform_1.jpg": 906,
	"./products-westudy/platform_1_mobile.jpg": 907,
	"./products-westudy/platform_1_tablet.jpg": 908,
	"./products-westudy/platform_2.jpg": 909,
	"./products-westudy/platform_2_mobile.jpg": 910,
	"./products-westudy/platform_2_tablet.jpg": 911,
	"./products-westudy/platform_3.jpg": 912,
	"./products-westudy/platform_3_mobile.jpg": 913,
	"./products-westudy/platform_3_tablet.jpg": 914,
	"./registration-1.jpg": 1300,
	"./registration-1@2x.jpg": 1301,
	"./registration-2.jpg": 1302,
	"./registration-2@2x.jpg": 1303,
	"./registration-3-test.jpg": 1304,
	"./registration-3.jpg": 1305,
	"./registration-3@2x.jpg": 1306,
	"./registration-4.jpg": 1307,
	"./registration-4@2x.jpg": 1308,
	"./registration-5.jpg": 1309,
	"./registration-5@2x.jpg": 1310,
	"./registration-6.jpg": 1311,
	"./registration-6@2x.jpg": 1312,
	"./reviews-author-11.jpg": 1313,
	"./reviews-author-11@2x.jpg": 1314,
	"./reviews-author-12.jpg": 1315,
	"./reviews-author-12@2x.jpg": 1316,
	"./reviews-author-13.jpg": 1317,
	"./reviews-author-13@2x.jpg": 1318,
	"./reviews-author-14.jpg": 1319,
	"./reviews-author-14@2x.jpg": 1320,
	"./reviews-author-15.jpg": 1321,
	"./reviews-author-16.jpg": 1322,
	"./reviews-author-17.jpg": 1323,
	"./reviews/review-photo-1.jpg": 553,
	"./reviews/review-photo-2.jpg": 1324,
	"./rudn-1.jpg": 1325,
	"./signup/signup-background.jpg": 226,
	"./skin-detail-completo-promo.jpg": 1326,
	"./skin-detail-completo-review-avatar.jpg": 1327,
	"./skin-detail-completo-video-poster.jpg": 1328,
	"./skin-detail-msu-review-avatar.jpg": 1329,
	"./skin-detail-msu-spec-block.jpg": 1330,
	"./skin-detail-msu-video-poster.jpg": 1331,
	"./skin-detail-promo-msu.jpg": 1332,
	"./skin-detail-review-bg.jpg": 1333,
	"./skin-detail-use-functions-bg.jpg": 1334,
	"./skin-fokus-media.jpg": 1335,
	"./skin-ilearney.jpg": 1336,
	"./skin-rudn.jpg": 1337,
	"./support-promo-bg-900-599.jpg": 639,
	"./support-promo-bg.jpg": 638,
	"./tariffs/product-detail-promo-bg.jpg": 534,
	"./task/common-healthcare/background_gradient.jpg": 463,
	"./task/common-healthcare/background_gradient_mobile.jpg": 1338,
	"./task/common-healthcare/background_violet.jpg": 508,
	"./task/common-healthcare/form_image.jpg": 464,
	"./task/common-healthcare/form_image_mobile.jpg": 487,
	"./task/common-healthcare/form_image_tablet.jpg": 488,
	"./task/common-healthcare/image_1.jpg": 509,
	"./task/common-healthcare/image_1_mobile.jpg": 510,
	"./task/common-healthcare/image_2.jpg": 535,
	"./task/common-healthcare/image_2_mobile.jpg": 536,
	"./task/common-healthcare/image_3.jpg": 684,
	"./task/common-healthcare/image_3_mobile.jpg": 685,
	"./task/common-healthcare/image_4.jpg": 537,
	"./task/common-healthcare/image_4_mobile.jpg": 538,
	"./task/common-healthcare/image_5.jpg": 686,
	"./task/common-healthcare/image_5_mobile.jpg": 687,
	"./task/common-healthcare/image_5_tablet.jpg": 688,
	"./task/common-healthcare/image_6.jpg": 689,
	"./task/common-healthcare/image_6_mobile.jpg": 690,
	"./task/common-healthcare/image_6_tablet.jpg": 691,
	"./task/common-healthcare/image_7.jpg": 692,
	"./task/common-healthcare/image_7_mobile.jpg": 693,
	"./task/common-healthcare/image_7_tablet.jpg": 694,
	"./task/common-healthcare/image_8.jpg": 539,
	"./task/common-healthcare/image_8_mobile.jpg": 540,
	"./task/education/devices_2_1920.jpg": 574,
	"./task/education/devices_2_375.jpg": 695,
	"./task/education/devices_2_768.jpg": 575,
	"./task/education/devices_3_1920.jpg": 576,
	"./task/education/devices_3_375.jpg": 696,
	"./task/education/devices_3_768.jpg": 577,
	"./task/education/form_1920.jpg": 520,
	"./task/education/tools_1_1920.jpg": 578,
	"./task/education/tools_1_768.jpg": 579,
	"./task/education/tools_2_1920.jpg": 580,
	"./task/education/tools_2_768.jpg": 581,
	"./task/education/who-is-suitable_1_1920.jpg": 582,
	"./task/education/who-is-suitable_2_1920.jpg": 583,
	"./task/education/who-is-suitable_3_1920.jpg": 584,
	"./task/healthcare/form-image.jpg": 541,
	"./task/healthcare/image.jpg": 697,
	"./task/healthcare/image_mobile.jpg": 698,
	"./task/healthcare/image_tablet.jpg": 699,
	"./task/healthcare/promo.jpg": 700,
	"./task/healthcare/promo_mobile.jpg": 701,
	"./task/healthcare/promo_tablet.jpg": 702,
	"./task/med/alternate_1.jpg": 703,
	"./task/med/alternate_1_mobile.jpg": 585,
	"./task/med/alternate_1_tablet.jpg": 704,
	"./task/med/alternate_2.jpg": 705,
	"./task/med/alternate_2_mobile.jpg": 586,
	"./task/med/alternate_2_tablet.jpg": 706,
	"./task/med/alternate_3.jpg": 707,
	"./task/med/alternate_3_mobile.jpg": 587,
	"./task/med/alternate_3_tablet.jpg": 708,
	"./task/med/promo.jpg": 709,
	"./task/med/promo_mobile.jpg": 710,
	"./task/nmo/image_1.jpg": 711,
	"./task/nmo/image_1_mobile.jpg": 712,
	"./task/nmo/image_3.jpg": 542,
	"./task/nmo/promo.jpg": 713,
	"./task/nmo/promo_mobile.jpg": 714,
	"./task/nmo/promo_tablet.jpg": 1341,
	"./task/ouz/image_1.jpg": 715,
	"./task/ouz/image_2.jpg": 716,
	"./task/ouz/image_3.jpg": 717,
	"./task/ouz/image_4.jpg": 718,
	"./task/ouz/image_5.jpg": 719,
	"./task/ouz/image_6.jpg": 720,
	"./task/ouz/image_6_mobile.jpg": 721,
	"./task/ouz/image_6_tablet.jpg": 722,
	"./task/ouz/promo.jpg": 723,
	"./task/ouz/promo_mobile.jpg": 724,
	"./task/pharma/image_1.jpg": 725,
	"./task/pharma/image_1_mobile.jpg": 726,
	"./task/pharma/image_2.jpg": 727,
	"./task/pharma/image_2_tablet.jpg": 728,
	"./task/pharma/image_3.jpg": 729,
	"./task/pharma/image_4.jpg": 730,
	"./task/pharma/image_5.jpg": 731,
	"./task/pharma/image_6.jpg": 732,
	"./task/pharma/image_6_mobile.jpg": 733,
	"./task/pharma/promo.jpg": 734,
	"./task/pharma/promo_mobile.jpg": 735,
	"./task/pharma/promo_tablet.jpg": 736,
	"./why-choose/why-choose-bg-900-735.jpg": 1342,
	"./why-choose/why-choose-bg.jpg": 1343,
	"./yaroslav_feshin.jpg": 1344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 457;